( function( $, document ) {
    'use strict';

    $( document ).ready( function() {
    	$('.js-read-more__hidden').after('<button class="read-more__button  js-read-more-button">Read More</button>');
    	
    	$('.read-more__button').click(function () {
    		$('.js-read-more__hidden').css("display", "block");
    		$('.js-read-more-button').css("display", "none");
    	});
    } );

} )( jQuery, document );
